import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileBanner.css';
import PlayButton from '../components/PlayButton';
import { getProfileBanner } from '../data/localDataService';
import { ProfileBanner as ProfileBannerType } from '../types';

const ProfileBanner: React.FC = () => {
  const navigate = useNavigate();

  const [bannerData, setBannerData] = useState<ProfileBannerType | null>(null);

  useEffect(() => {
    async function fetchData() {
      const data = await getProfileBanner();
      setBannerData(data);
    }
    fetchData();
  }, []);

  if (!bannerData) return <div>Loading...</div>;

  const handlePlayClick = () => {
    window.scrollTo(0, 0);
    navigate('/resume');
  };

  // Get the current profile from URL
  const currentProfile = window.location.pathname.split('/').pop();
  
  // Determine which background GIF to use based on profile
  const getBackgroundGif = () => {
    if (currentProfile === 'stalker') {
      return '/assets/backgrounds/stalker_duolingo.gif';
    }
    return null;
  };

  const backgroundGif = getBackgroundGif();

  return (
    <div 
      className="profile-banner"
      style={backgroundGif ? {
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7)), url(${backgroundGif})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      } : {}}
    >
      <div className="banner-content">
        <h1 className="banner-headline" id='headline'>{bannerData.headline}</h1>
        <p className="banner-description">
          {bannerData.profileSummary}
        </p>

        <div className="banner-buttons">
          <PlayButton onClick={handlePlayClick} label="Resume" />
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
